/**
 * Production singleton for the content-addressed asset store (Bombproof storage
 * foundation, Layer 2). Wires the {@link AssetStore} to the persistent
 * {@link IndexedDbAssetBackend} (dedicated DB `stagecraft_assets`).
 *
 * The backend opens its IndexedDB connection LAZILY (on first put/get/has), so
 * importing this singleton is free until the asset seam actually offloads or
 * resolves an image — an image-free save/load never touches IndexedDB.
 *
 * Consumed by the asset seam (`assetSeam.ts`) wired into `ElementStorage`. Tests
 * that need to inspect the store mock THIS module to an in-memory-backed store.
 */
import { AssetStore } from "./assetStore";
import { IndexedDbAssetBackend } from "./indexedDbAssetBackend";

export const assetStore = new AssetStore(new IndexedDbAssetBackend());
